module.exports = __webpack_public_path__ + "static/media/ArrowLeft.e74d2c36.svg";